export default class QueryStringUtility {
  static getQueryString(arg: {[key: string]: any|undefined}) {
    let queryString = ''
    let appendChar = '?'
    for(const f in arg) {
        //if(arg.hasOwnProperty(f)) {
            const val = arg[f]
            if(val !== undefined) {
                queryString += `${appendChar}${f}=${val}`
                appendChar = '&'
            }
        //}
    }
    return queryString
  }

}